import React, { useEffect, useState } from 'react';

import Tooltip from './Tooltip';

import OpenIcon from '../assets/chat-icon.svg';

interface ChatMinimizedProps {
  openChat: () => void;
  openedYet: boolean;
}

function ChatMinimized({ openChat, openedYet }: ChatMinimizedProps): JSX.Element {
  const [showTooltip, setShowTooltip] = useState(false);
  const { rudderanalytics, document } = window;

  useEffect(() => {
    let tooltipTimer: number;
    // Bring on tooltip after 2 seconds if Chat hasn't been opened yet
    if (!openedYet) {
      tooltipTimer = window.setTimeout(() => {
        setShowTooltip(true);
      }, 2000);
    }
    return () => {
      window.clearTimeout(tooltipTimer);
    };
  }, [openedYet]);

  const onOpen = () => {
    rudderanalytics.track('open_chat', {
      mode: 'embed',
      popupsEnabled: null, // This data point is only helpful when mode is popup, so setting null here
      referrer: document.referrer || 'self',
    });
    openChat();
  };

  const closeTooltip = () => {
    setShowTooltip(false);
    window.parent.postMessage({ method: 'tooltipClosed' }, '*');
  };

  return (
    <div className="ChatMinimized">
      {showTooltip ? <Tooltip closeTooltip={closeTooltip} /> : null}
      <button data-testid="open-button" className="Open-button" type="button" onClick={onOpen}>
        <img src={OpenIcon} className="Open-button-icon" alt="open chat" />
      </button>
    </div>
  );
}

export default ChatMinimized;
